import behaviourSettings from "./behaviourSettings"
import behaviourManage from "./behaviourManage"

const behaviourModules = {
  behaviourSettings,
  behaviourManage
}
export default behaviourModules
